import Badge from './Badge';

const STATUS_CONFIG = {
  // Task statuses
  new:         { tone: 'insight',  label: 'New',         dot: true },
  assigned:    { tone: 'action',   label: 'Assigned',    dot: true },
  in_progress: { tone: 'action',   label: 'In Progress', dot: true },
  resolved:    { tone: 'recovery', label: 'Resolved',    dot: true },
  verified:    { tone: 'success',  label: 'Verified',    dot: true },
  rejected:    { tone: 'danger',   label: 'Rejected',    dot: true },

  // Refund states
  parts_to_return:  { tone: 'action',   label: 'Parts to Return' },
  refund_pending:   { tone: 'insight',  label: 'Refund Pending' },
  refund_complete:  { tone: 'success',  label: 'Refund Complete' },
  void:             { tone: 'neutral',  label: 'Void' },

  // Severity
  critical: { tone: 'danger',   label: 'Critical',  dot: true },
  warning:  { tone: 'action',   label: 'Warning',   dot: true },
  info:     { tone: 'insight',  label: 'Info',      dot: true },

  // General
  active:    { tone: 'success',  label: 'Active' },
  inactive:  { tone: 'neutral',  label: 'Inactive' },
  overdue:   { tone: 'danger',   label: 'Overdue',  dot: true },
  on_track:  { tone: 'success',  label: 'On Track' },
};

export default function StatusBadge({ status, size = 'sm', className = '', children }) {
  const config = STATUS_CONFIG[status] || { tone: 'neutral', label: status };
  return (
    <Badge tone={config.tone} size={size} dot={config.dot} className={className}>
      {children || config.label}
    </Badge>
  );
}
